import {Star} from 'lucide-react';
import {useRatingRadioGroupContext} from './RatingRadioGroupContext';
import type {RatingRadioGroupOption, RatingRadioGroupSize} from './types';

const ratingRadioGroupStarSizes: Record<RatingRadioGroupSize, number> = {
  default: 24,
  lg: 32,
};

const getStarColor = (optionValue: number) => (value: number, hoverValue?: number) => {
  const currentValue = hoverValue ?? value;
  if (currentValue >= optionValue) {
    return 'var(--rating-radio-group-star-selected-color)';
  }

  return 'var(--rating-radio-group-star-unselected-color)';
};

export type RatingRadioGroupItemProps = {
  option: RatingRadioGroupOption;
  size?: RatingRadioGroupSize;
};

export function RatingRadioGroupItem({option, size}: RatingRadioGroupItemProps) {
  const {
    name,
    value,
    size: contextSize,
    hoverValue,
    onChange,
    onMouseEnter,
    onTouchStart,
    onTouchEnd,
  } = useRatingRadioGroupContext();
  const starColor = getStarColor(option.value)(value, hoverValue);
  const starSize = ratingRadioGroupStarSizes[size ?? contextSize];

  return (
    <label
      onMouseEnter={() => onMouseEnter(option.value)}
      onTouchStart={() => onTouchStart(option.value)}
      onTouchEnd={onTouchEnd}
    >
      <input
        className="peer absolute h-0 w-0 opacity-0"
        type="radio"
        name={name}
        checked={value === option.value}
        value={option.value}
        onChange={() => onChange?.(option.value)}
      />
      <Star
        className="cursor-pointer rounded peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-[var(--rating-radio-group-star-focus-color)]"
        size={starSize}
        aria-label={option.label}
        color={starColor}
        fill={starColor}
      />
    </label>
  );
}
